import { gql } from "@apollo/client";

export enum PaymentMethod {
  Card = "card",
  Bank = "us_bank_account",
}

export interface Props {
  onComplete(paymentMethod: PaymentMethod): void;
  order: OrderType;
  proxyId?: string;
}

export const MUTATION = gql`
  mutation CreateMembershipOrderPaymentIntent($input: MembershipCreateOrderPaymentIntentInput!) {
    createPaymentIntent: createMembershipOrderPaymentIntent(input: $input) {
      merchantDisplayName
      paymentIntentClientSecret
      customerEphemeralKeySecret
      customerId
      customerName
      customerEmail
      total
    }
  }
`;

export const PROXY_MUTATION = gql`
  mutation CreateProxyPaymentIntent($input: MembershipPublicCreateProxyPaymentIntentInput!) {
    createPaymentIntent: createMembershipProxyPaymentIntent(input: $input) {
      merchantDisplayName
      paymentIntentClientSecret
      total
    }
  }
`;

export const PDF_QUERY = gql`
  query DuesQuery {
    duesCycle: currentDuesCycle {
      id
      order {
        id
        pdfUrl
      }
    }
  }
`;

export interface PdfQuery {
  duesCycle: {
    order: {
      pdfUrl: string;
    };
  };
}

export interface MutationInput {
  orderId: string;
  paymentMethod: PaymentMethod;
  addons: { productVariantLookupKey: string; priceCents: number }[];
}

export interface PaymentIntentResponseType {
  merchantDisplayName: string;
  paymentIntentClientSecret: string;
  total: number;
  customerEphemeralKeySecret?: string;
  customerId?: string;
  customerName?: string;
  customerEmail?: string;
}

export interface MutationResponseType {
  createPaymentIntent: PaymentIntentResponseType;
}

export interface LineItemType {
  id: string;
  name: string;
  priceCents: number;
}

export interface AddonType {
  productVariantLookupKey: string;
  name: string;
  priceCents: number;
  changeablePrice: boolean;
}

export enum OrderStage {
  DRAFT = "draft",
  OPEN = "open",
  PENDING = "pending",
  PAID = "paid",
  FAILED = "failed",
}

export interface OrderType {
  id: string;
  stage?: OrderStage;
  lineItems: LineItemType[];
  addons: AddonType[];
  creditCardFee: number;
}
